import { useUpsertIncidentStatusSummary } from 'components/IAP/hooks/incidentStatusSummaryHooks';
import { NotableItem } from 'types/iapBaseTypes';

import EditableListTable from './EditableListTable';

const NotableItemsTable = ({
  statusSummaryId,
  originalNotableItems = [],
  readOnly = false,
}: {
  statusSummaryId: string;
  originalNotableItems?: NotableItem[];
  readOnly?: boolean;
}) => {
  const upsertIncidentStatusSummary =
    useUpsertIncidentStatusSummary(statusSummaryId);

  return (
    <EditableListTable<NotableItem>
      itemsLabel="notable items"
      itemLabel="Notable Item"
      testId="ics209-notable-items"
      columns={[
        { key: 'item', label: 'Notable Item' },
        {
          key: 'numberThisReportingPeriod',
          label: 'Total This Reporting Period',
        },
        { key: 'totalNumberToDate', label: 'Total To Date' },
      ]}
      blank={{ item: '', numberThisReportingPeriod: '', totalNumberToDate: '' }}
      primaryKey="item"
      values={originalNotableItems}
      readOnly={readOnly}
      onChange={(notableItems) => upsertIncidentStatusSummary({ notableItems })}
    />
  );
};

export default NotableItemsTable;
